import { getAllUrlParams, useAPI } from "../../../../../lib/common";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePictureSets } from "../../../../hooks/usePictureSets";
import useTemplateList from "../../../hooks/useTemplateList";
import { useLocation } from "../../../../hooks/useRoutes";
import useGoogleFonts from "../../../../../hooks/useGoogleFonts";
import { templateFontList } from "../../../Components/EditTemplateProduct/common";
import useTemplateFilters from "../../../hooks/useTemplateFilters";
import useFilteredTemplateList from "../../../hooks/useFilteredTemplateList";
import SubHeader from "../../../Components/SubHeader";
import FiltersDialog from "../../../../Components/Template/FiltersDialog";

import TypeOptions from "./TypeOptions";
import ListTemplatesPage from "./ListTemplatesPage";
import I18n from "../../../../../i18n";

const CardWrapper = ({ type, category }) => {
  const [data, loading] = useAPI(`/api/webshop/templates/cards/categories`);
  const [cat, setCategory] = useState(category);
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const { currentPictureSet } = usePictureSets();
  const options = useMemo(() => {
    return {
      pictureSet: currentPictureSet,
      // Not really used except for getting the template list to reload
      language: i18n.language,
    };
  }, [currentPictureSet, i18n.language]);

  const [templateList, loadingTemplates] = useTemplateList(type, cat, options);
  const { loaded: fontsLoaded } = useGoogleFonts(templateFontList);

  // Get params as an object:
  const params = useMemo(() => {
    // Hack to trigger a scroll event (For templates to show)
    window.scrollTo(window.scrollX, window.scrollY - 1);
    window.scrollTo(window.scrollX, window.scrollY + 1);
    return getAllUrlParams(location.search);
  }, [location]);

  console.log("The params is", params);

  const filterOptions = useMemo(() => {
    return {
      filters: ["formats", "texts", "images"],
      predef: params,
    };
  }, [params]);
  const [filters, toggleFilterOption] = useTemplateFilters(
    templateList,
    filterOptions,
  );
  const filteredTemplates = useFilteredTemplateList(templateList, filters);

  const [filtersOpen, setFiltersOpen] = useState(false);

  useEffect(() => {
    console.log("Card wrapper", loading, data);
    if (!data) {
      return;
    }
    console.log(">Category", category, data);
    if (category) {
      setCategory(category);
    } else {
      setCategory(data.defaultCategory);
    }
  }, [data, category]);

  const handleChangeCategory = (category) => {
    setCategory(category);
  };

  return (
    <>
      <SubHeader title={t("Cards")} subtitle={t("Choose template")} />
      <TypeOptions
        type={"cards"}
        category={cat}
        categories={data?.categories || []}
        handleChangeCategory={handleChangeCategory}
        setFiltersOpen={setFiltersOpen}
        filters={filters}
        toggleFilterOption={toggleFilterOption}
      />
      <ListTemplatesPage
        loading={loadingTemplates || !fontsLoaded || !cat}
        type={type}
        category={cat}
        templates={filteredTemplates}
        allTemplates={templateList.templates}
        canViewWithOwnPictures={false}
        separateFromBackground={true}
      />
      {filtersOpen && (
        <FiltersDialog
          filters={filters}
          toggleFilterOption={toggleFilterOption}
          templates={templateList.templates}
          filteredTemplates={filteredTemplates}
          onClose={() => setFiltersOpen(false)}
          onOpen={() => setFiltersOpen(true)}
        />
      )}
    </>
  );
};

export default CardWrapper;
